import { Button, Col, Drawer, Form, Input, InputNumber, message, Row, Select, Spin } from "antd";
import HandleNotification from "common/Notification";
import DrawerFormSize from "./DrawerFormSize";
import { LoadingOutlined, PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import { postData } from "apiServices/common";
import { SIZE_QTY_UPLOAD_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { useState, useEffect } from "react";

const DrawerForm = ({ props, open = false, setOpen, useBothStylePo, setPoDetailsData, breakdownType, addNewRow }) => {
  const {
    view,
    poDetailsData,
    purchesList,
    unique_id,
    styleList,
    isArrayAndHasValue,
    dynamicSizeList,
    commaSeparateNumber,
    form,
    aIsEdit,
    setAIsEdit,
    setUniqueId,
  } = props;

  const { Option } = Select;
  const [csvImportLoading, setCsvImportLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (open && aIsEdit && unique_id !== undefined && poDetailsData?.[unique_id]) {
      const currentPoItem = poDetailsData[unique_id];
      const styleId = currentPoItem?.style_id || currentPoItem?.style?.id;

      if (styleId && (!currentPoItem?.style?.color_map || !isArrayAndHasValue(currentPoItem?.style?.color_map))) {
        const foundStyle = styleList?.find((item) => item?.style_info?.id === styleId);

        if (foundStyle?.style_info) {
          const poDetailsDataCopy = structuredClone(poDetailsData);
          const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);

          if (foundPoItem && foundStyle.style_info.color_map) {
            foundPoItem.style = {
              ...foundPoItem.style,
              color_map: foundStyle.style_info.color_map,
              sub_style_map: foundStyle.style_info.sub_style_map || foundPoItem.style?.sub_style_map,
            };

            setPoDetailsData(poDetailsDataCopy);
          }
        }
      }
    }
  }, [open, aIsEdit, unique_id, styleList, poDetailsData]);

  const onClose = () => {
    if (!aIsEdit) {
      const poDetailsDataCopy = [...poDetailsData];
      poDetailsDataCopy.splice(unique_id, 1);
      setPoDetailsData(poDetailsDataCopy);
    }

    setOpen(false);
    form.resetFields();
  };

  const checkOrderQuantityMoreThan = (list) => {
    const sameStyle = list.filter((item) => item.style_id === list[unique_id].style_id);

    const orderQuantity = parseInt(list[unique_id].order_quantity);

    const totalQuantity = sameStyle?.reduce((acc, item) => {
      return (
        acc +
        item?.sizes?.reduce((acc, size) => {
          return acc + size.sales_order_quantity;
        }, 0)
      );
    }, 0);

    // if (totalQuantity > orderQuantity) {
    //   message.error("Order Quantity is more than Style Quantity");
    //   return true;
    // }
  };

  const applyFormValuesToPoDetails = (formValues) => {
    const poDetailsDataCopy = structuredClone(poDetailsData);
    const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);

    if (!foundPoItem) return;

    if (formValues.original_po !== undefined) {
      foundPoItem.original_po = formValues.original_po;
      const foundPoItemOriginal = purchesList.find((item) => item.original_po === formValues.original_po);
      if (foundPoItemOriginal) {
        foundPoItem.internal_po = foundPoItemOriginal.internal_po;
        foundPoItem.po_map_id = foundPoItemOriginal.id;
        foundPoItem.delivery_date = foundPoItemOriginal.delivery_date || null;
      }
    }

    if (formValues.internal_po !== undefined) {
      foundPoItem.internal_po = formValues.internal_po;
      const foundPoItemInternal = purchesList.find((item) => item.internal_po === formValues.internal_po);
      if (foundPoItemInternal) {
        foundPoItem.original_po = foundPoItemInternal.original_po;
        foundPoItem.po_map_id = foundPoItemInternal.id;
        foundPoItem.delivery_date = foundPoItemInternal.delivery_date || null;
      }
    }

    if (formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle) {
        const foundStyleInfo = foundStyle?.style_info;
        foundPoItem.style = foundStyleInfo;
        foundPoItem.style_id = foundStyleInfo?.id;
        foundPoItem.order_quantity = foundStyle?.order_quantity;
        foundPoItem.brand_info = foundStyleInfo?.brand_info;

        const subStyle = foundStyleInfo?.sub_style;
        foundPoItem.color_list_obj = subStyle;
      }
    }

    if (formValues.sub_style_id !== undefined && formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle && foundStyle.style_info) {
        const foundSubStyleInfo = foundStyle.style_info?.sub_style_map?.find(
          (subStyle) => subStyle?.id === formValues.sub_style_id,
        );
        if (foundSubStyleInfo) {
          foundPoItem.sub_style_info = foundSubStyleInfo;
        }
      }
    }

    if (formValues.color_id !== undefined && formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle && foundStyle.style_info) {
        const foundColorInfo = foundStyle.style_info?.color_map?.find(
          (colorItem) => colorItem?.color_info?.id === formValues.color_id,
        );
        if (foundColorInfo) {
          foundPoItem.color = foundColorInfo;
          foundPoItem.color_id = foundColorInfo?.color_info?.id;
        }
      }
    }

    if (formValues.unit_price !== undefined) {
      foundPoItem.unit_price = formValues.unit_price || 0;

      if (foundPoItem.sizes) {
        foundPoItem.sizes = foundPoItem.sizes.map((size) => ({
          ...size,
          sales_order_price: formValues.unit_price || 0,
          common_price: 1,
        }));
      }
    }

    if (formValues.extra_cutting !== undefined) {
      foundPoItem.extra_cutting = formValues.extra_cutting || 0;
    }

    if (!foundPoItem.sizes) {
      foundPoItem.sizes = [];
    }

    if (dynamicSizeList) {
      dynamicSizeList.forEach((size) => {
        const sizeKey = `${size.label}_${size.value}`;
        const sizeValue = formValues[sizeKey];

        if (sizeValue !== undefined && sizeValue !== null) {
          const foundSize = foundPoItem.sizes.find((item) => item.id === size.value);

          if (foundSize) {
            if (breakdownType === "1") {
              foundSize.sales_order_quantity = sizeValue;
            } else {
              foundSize.sales_order_price = sizeValue;
            }
          } else {
            foundPoItem.sizes.push({
              id: size.value,
              name: size.label,
              ...(breakdownType === "1" && { sales_order_quantity: sizeValue }),
              sales_order_price: breakdownType === "0" ? sizeValue : foundPoItem?.unit_price || 0,
              delivery_date: foundPoItem?.delivery_date || poDetailsDataCopy?.[0]?.sizes?.[0]?.delivery_date,
              po_detail_id: foundPoItem?.po_detail_id || 0,
              po_map_id: foundPoItem?.po_map_id,
            });
          }
        }
      });
    }

    if (foundPoItem.po_map_id && foundPoItem.sizes) {
      foundPoItem.sizes = foundPoItem.sizes.map((size) => ({
        ...size,
        po_map_id: foundPoItem.po_map_id,
      }));
    }

    setPoDetailsData(poDetailsDataCopy);
  };

  // Normalize ids so duplicate check works even if data shape varies
  const normalizeIds = (item = {}) => {
    const styleId = item?.style_id || item?.style?.id;
    const subStyleId = item?.sub_style_id || item?.sub_style_info?.id;
    const colorId = item?.color_id || item?.color?.color_info?.id || item?.color?.id;
    const poMapId = item?.po_map_id;
    return { styleId, subStyleId, colorId, poMapId };
  };

  const onFinish = (formValues) => {
    if (checkOrderQuantityMoreThan(poDetailsData)) {
      return;
    }

    if (aIsEdit) {
      let po_map_id = poDetailsData.find((item) => item?.unique_id === unique_id)?.po_map_id;
      const { styleId: style_id, subStyleId: sub_style_id, colorId: color_id } = normalizeIds(formValues);

      if (formValues.original_po !== undefined) {
        const foundPoItemOriginal = purchesList.find((item) => item.original_po === formValues.original_po);
        if (foundPoItemOriginal) {
          po_map_id = foundPoItemOriginal.id;
        }
      }
      if (formValues.internal_po !== undefined) {
        const foundPoItemInternal = purchesList.find((item) => item.internal_po === formValues.internal_po);
        if (foundPoItemInternal) {
          po_map_id = foundPoItemInternal.id;
        }
      }

      const duplicateFound = poDetailsData.some((item) => {
        if (item?.unique_id === unique_id) return false;
        if (item?.is_delete === 1) return false;

        const { styleId, subStyleId, colorId, poMapId } = normalizeIds(item);

        return poMapId === po_map_id && styleId === style_id && subStyleId === sub_style_id && colorId === color_id;
      });

      if (duplicateFound) {
        HandleNotification(
          "error",
          "bottomRight",
          "Duplicate style, sub style, or color found in the purchase order details",
          null,
        );
        return;
      }

      applyFormValuesToPoDetails(formValues);
    } else {
      // Check for duplicates before applying form values
      let po_map_id = null;
      if (formValues.original_po !== undefined) {
        const foundPoItemOriginal = purchesList.find((item) => item.original_po === formValues.original_po);
        if (foundPoItemOriginal) {
          po_map_id = foundPoItemOriginal.id;
        }
      }
      if (formValues.internal_po !== undefined) {
        const foundPoItemInternal = purchesList.find((item) => item.internal_po === formValues.internal_po);
        if (foundPoItemInternal) {
          po_map_id = foundPoItemInternal.id;
        }
      }

      const { styleId: style_id, subStyleId: sub_style_id, colorId: color_id } = normalizeIds(formValues);

      const duplicateFound = poDetailsData.some((item) => {
        if (item?.unique_id === unique_id) return false;
        if (item?.is_delete === 1) return false;

        const { styleId, subStyleId, colorId, poMapId } = normalizeIds(item);

        return poMapId === po_map_id && styleId === style_id && subStyleId === sub_style_id && colorId === color_id;
      });

      if (duplicateFound) {
        HandleNotification(
          "error",
          "bottomRight",
          "Duplicate style, sub style, or color found in the purchase order details",
          null,
        );
        return;
      }

      // Apply form values to the current row
      applyFormValuesToPoDetails(formValues);
    }

    // Close drawer and reset form for both edit and add cases
    setOpen(false);
    setAIsEdit(false);
    setUniqueId(0);
    form.resetFields();
  };

  const filterOption = (input, option) => {
    return option?.children != null && option.children.toLowerCase().includes(input.toLowerCase());
  };

  const onChangeUnitPrice = (value, unique_id) => {};

  const currentStyleId = Form.useWatch("style_id", form);
  const currentStyle = styleList?.find(
    (item) => item?.style_info?.id === currentStyleId || item?.style_id === currentStyleId,
  );
  const currentStyleInfo = currentStyle?.style_info;

  const isSubstyleExists = () => {
    const substyles =
      currentStyleInfo?.sub_style_map ||
      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.sub_style_map;
    const isExists = isArrayAndHasValue(substyles) && substyles?.some((item) => item?.sub_style_no);
    return isExists || false;
  };

  const importFromCSV = async (file) => {
    if (!file) {
      message.error("Please select a CSV file");
      return;
    }

    if (!file.name.toLowerCase().endsWith(".csv")) {
      message.error("Please select a valid CSV file");
      return;
    }

    try {
      setCsvImportLoading(true);
      const formData = new FormData();
      formData.append("csv_file", file);
      formData.append("type", "PO Break Down");

      if (unique_id) {
        formData.append("unique_id", unique_id);
      }

      const response = await postData(SIZE_QTY_UPLOAD_ENDPOINT, formData);

      if (response && response.status === "success") {
        message.success("CSV imported successfully");

        const { details, common_unit_price } = response.data;
        const formValues = {};

        if (common_unit_price && breakdownType === "1") {
          formValues.unit_price = parseFloat(common_unit_price);
        } else {
          formValues.unit_price = common_unit_price || 0;
        }

        const sortedSizeList = [...(dynamicSizeList || [])].sort((a, b) => {
          const aLabel = a.label?.toString().toLowerCase().trim() || "";
          const bLabel = b.label?.toString().toLowerCase().trim() || "";
          return bLabel.length - aLabel.length;
        });

        const sizeUpdates = [];

        details.forEach((item) => {
          const csvName = item.name?.toString().toLowerCase().trim();
          let matchingSize = null;

          matchingSize = sortedSizeList?.find((size) => {
            const sizeLabel = size.label?.toString().toLowerCase().trim();
            const sizeValue = size.value?.toString().toLowerCase().trim();
            const labelValuePattern = `${sizeLabel}_${sizeValue}`;

            return csvName === sizeLabel || csvName === sizeValue || csvName === labelValuePattern;
          });

          if (!matchingSize) {
            matchingSize = sortedSizeList?.find((size) => {
              const sizeLabel = size.label?.toString().toLowerCase().trim();
              const sizeValue = size.value?.toString().toLowerCase().trim();

              if (sizeLabel) {
                const labelRegex = new RegExp(`\\b${sizeLabel.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
                if (labelRegex.test(csvName)) return true;
              }

              if (sizeValue) {
                const valueRegex = new RegExp(`\\b${sizeValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
                if (valueRegex.test(csvName)) return true;
              }

              return false;
            });
          }

          if (!matchingSize) {
            matchingSize = sortedSizeList?.find((size) => {
              const sizeLabel = size.label?.toString().toLowerCase().trim();
              const sizeValue = size.value?.toString().toLowerCase().trim();

              if (sizeLabel && csvName.includes(sizeLabel)) return true;
              if (sizeValue && csvName.includes(sizeValue)) return true;
              if (sizeValue && csvName.endsWith(sizeValue)) return true;

              return false;
            });
          }

          if (matchingSize) {
            const fieldName = `${matchingSize.label}_${matchingSize.value}`;

            if (breakdownType === "1") {
              formValues[fieldName] = parseInt(item.sales_order_quantity) || 0;
            } else {
              formValues[fieldName] = parseFloat(item.sales_order_price) || 0;
            }

            sizeUpdates.push({
              matchingSize,
              sales_order_quantity: item.sales_order_quantity,
              sales_order_price: item.sales_order_price,
            });
          }
        });

        form.setFieldsValue(formValues);
      } else {
        message.error(response?.message || "Failed to import CSV");
      }
    } catch (error) {
      message.error("Error occurred while importing CSV");
    } finally {
      setCsvImportLoading(false);
    }
  };

  return (
    <>
      <Drawer
        title="Create a new PO Style"
        width={720}
        onClose={onClose}
        open={open}
        styles={{ body: { paddingBottom: 80 } }}
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col className="gutter-row" span={0}>
              <Form.Item label="Internal PO" name="internal_po" style={{ marginBottom: "unset" }} hidden>
                <Select
                  className="w-100"
                  showSearch
                  disabled={view}
                  dropdownStyle={{ minWidth: 250 }}
                  optionFilterProp="children"
                  placeholder="Select an Internal PO"
                  size="small"
                  onChange={(value) => {
                    purchesList?.forEach((item) => {
                      if (item.internal_po === value) {
                        form.setFieldsValue({
                          original_po: item.original_po,
                        });
                      }
                    });
                  }}
                  filterOption={(input, option) => filterOption(input, option)}
                >
                  {purchesList?.length &&
                    purchesList.map((sup, index) => (
                      <Option value={sup.internal_po || undefined} key={`internal_po_key_${index}`}>
                        {sup.internal_po}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                label={"Original PO"}
                name={"original_po"}
                rules={[
                  {
                    required: useBothStylePo === "No" ? false : true,
                    message: "Please Select Original PO!",
                  },
                ]}
                style={{ marginBottom: "unset" }}
              >
                <Select
                  className="w-100"
                  showSearch
                  disabled={view || breakdownType === "0"}
                  dropdownStyle={{ minWidth: 250 }}
                  optionFilterProp="children"
                  placeholder="Select an Original PO"
                  size="small"
                  onChange={(value) => {
                    purchesList?.forEach((item) => {
                      if (item.original_po === value) {
                        form.setFieldsValue({
                          internal_po: item.internal_po,
                        });
                      }
                    });
                  }}
                  filterOption={(input, option) => filterOption(input, option)}
                >
                  {purchesList?.length &&
                    purchesList.map((sup, index) => {
                      return (
                        <Option value={sup?.original_po || undefined} key={`original_po_key_${index}`}>
                          {sup?.original_po}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Please Select Style",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label={"Style"}
                name="style_id"
              >
                <Select
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {
                    const foundStyle = styleList?.find((item) => item?.style_id === value);
                    const foundStyleInfo = foundStyle?.style_info;

                    form.setFieldsValue({
                      color_id: foundStyleInfo?.color_map[0]?.color_id || null,
                      sub_style_id: foundStyleInfo?.sub_style_map[0]?.id || null,
                      brand: foundStyleInfo?.brand_info?.name || null,
                    });
                  }}
                  className="w-100"
                  showSearch
                  placeholder="Select a color"
                  optionFilterProp="children"
                  disabled={view || breakdownType === "0"}
                  size="small"
                >
                  {isArrayAndHasValue(styleList) &&
                    styleList.map((styleItem, index) => {
                      return (
                        <Option
                          value={styleItem?.style_id || styleItem?.style_info?.id || undefined}
                          key={`style_id_key_${index}`}
                        >
                          {`${styleItem?.style_info?.style_no || ""}${styleItem?.style_info?.description ? ":" : ""}${
                            styleItem?.style_info?.description || ""
                          }`}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={isSubstyleExists() ? 12 : 0}>
              <Form.Item
                name="sub_style_id"
                rules={[
                  {
                    required: isSubstyleExists(),
                    message: "Please Select Substyle",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label="Sub Style"
                hidden={isSubstyleExists() ? false : true}
              >
                <Select
                  name="sub_style_id"
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {}}
                  className="w-100"
                  showSearch
                  placeholder="Select a substyle"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option?.children != null) {
                      return option.children.toLowerCase().includes(input.toLowerCase());
                    }
                  }}
                  disabled={view || breakdownType === "0"}
                  size="small"
                >
                  {isArrayAndHasValue(currentStyleInfo?.sub_style_map) &&
                    currentStyleInfo?.sub_style_map?.map((subStyle, index) => {
                      return (
                        <Option value={subStyle?.id || undefined} key={subStyle?.id}>
                          {subStyle?.sub_style_no || subStyle?.color_info?.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                name={"color_id"}
                rules={[
                  {
                    required: true,
                    message: "Please Select Color",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label={"Color"}
              >
                <Select
                  name={"color_id"}
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {}}
                  className="w-100"
                  showSearch
                  placeholder="Select an Style No"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option?.children != null) {
                      return option.children.toLowerCase().includes(input.toLowerCase());
                    }
                  }}
                  disabled={view || breakdownType === "0"}
                  size="small"
                >
                  {isArrayAndHasValue(currentStyleInfo?.color_map) &&
                    currentStyleInfo?.color_map?.map((colorItem, index) => {
                      return (
                        <Option value={colorItem?.color_info?.id || undefined} key={colorItem?.color_info?.id}>
                          {colorItem?.color_info?.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={0}>
              <Form.Item name="brand" style={{ marginBottom: "unset" }} label="Brand" hidden>
                <Input size="small" disabled />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={breakdownType === "1" ? 12 : 0}>
              <Form.Item label={"Unit Price"} name={`unit_price`} style={{ marginBottom: "unset" }}>
                <InputNumber
                  style={{ width: "100%" }}
                  disabled={view || breakdownType === "0"}
                  size="small"
                  onChange={(value) => {
                    onChangeUnitPrice(value, unique_id);
                  }}
                  placeholder="Unit Price"
                  precision={8}
                  formatter={(value) => {
                    if (value === null || value === undefined || value === "") return "";
                    const numValue = Number(value);
                    if (isNaN(numValue)) return "";
                    return numValue.toFixed(8).replace(/\.?0+$/, "");
                  }}
                  parser={(value) => {
                    if (!value) return "";
                    return value.replace(/\$\s?|(,*)/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={breakdownType === "1" ? 12 : 0}>
              <Form.Item label={"Extra Cutting"} name={"extra_cutting"} style={{ marginBottom: "unset" }}>
                <InputNumber
                  style={{ width: "100%" }}
                  disabled={view || breakdownType === "0"}
                  size="small"
                  placeholder="Extra Cutting"
                  precision={2}
                  min={0}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Col span={12}>
              <Form.Item colon={false} style={{ marginTop: "12px" }}>
                <input
                  type="file"
                  id="file-input-bom"
                  hidden
                  accept=".csv"
                  onChange={(e) => importFromCSV(e.target.files[0])}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
                <Button
                  icon={csvImportLoading ? <LoadingOutlined style={{ fontSize: 16 }} spin /> : <UploadOutlined />}
                  type="primary"
                  size="small"
                  onClick={() => document.getElementById("file-input-bom").click()}
                >
                  Import from CSV
                </Button>
              </Form.Item>
            </Col>

            <Col span={12}>
              <a
                href={`${baseUrl}/${`storage/CsvUpload/template_unit_price size_break_down.csv`}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "16px", color: "#1890ff" }}
              >
                <PaperClipOutlined /> Download Template
              </a>
            </Col>
          </Row>

          {isArrayAndHasValue(dynamicSizeList) && (
            <Spin spinning={csvImportLoading}>
              <DrawerFormSize
                view={view}
                dynamicSizeList={dynamicSizeList}
                commaSeparateNumber={commaSeparateNumber}
                breakdownType={breakdownType}
                form={form}
              />
            </Spin>
          )}
          <Row gutter={8} className="mt-4">
            <Col span={12}>
              <Button style={{ width: "100%" }} type="primary" htmlType="submit" size="small">
                {aIsEdit ? `Update` : `Add`}
              </Button>
            </Col>
            <Col span={12}>
              <Button style={{ width: "100%" }} type="danger" size="small" onClick={onClose}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default DrawerForm;
